export default "__VITE_ASSET__8UIazvxz__$_?component__"